import { render } from "./DocumentsInformatique.vue?vue&type=template&id=348cae32"
import script from "./DocumentsInformatique.vue?vue&type=script&lang=js"
export * from "./DocumentsInformatique.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__